import { withLangPrefix, toLogicalPath, type Lang } from './lang'

/**
 * Normalize internal route anchors (`<a href="/...">`) to the canonical public
 * URL for the active language — i.e. language-prefixed (/ko/...) and with a
 * trailing slash — so crawlers and the prerenderer follow the 200 URL instead
 * of hitting a redirect. This is a single delegated pass instead of touching
 * every component that builds an anchor; click handlers still dispatch the
 * logical path, and the router re-derives it.
 *
 * Skips anchors that are external, or point at static files (e.g. the
 * printable career HTML, logos).
 */
export function localizeAnchors(root: ParentNode, lang: Lang): void {
  const anchors = root.querySelectorAll<HTMLAnchorElement>('a[href^="/"]')
  anchors.forEach((a) => {
    // Explicit cross-language original/translation links keep their destination.
    if (a.hasAttribute('data-preserve-locale')) return
    const href = a.getAttribute('href')
    if (!href || !href.startsWith('/')) return
    // Static file (extension in the last path segment) — leave as-is
    if (/\/[^/]*\.[a-z0-9]+$/i.test(href)) return
    a.setAttribute('href', withLangPrefix(toLogicalPath(href), lang))
  })
}
